<template>
  <div class="flex h-12 my-2 justify-between" style='box-sizing:border-box'>
    <slot name='left' />
    <pbc-button @click='showMenu = !showMenu'>
      <menu-icon class="w-8 h-6" :size='28' />
    </pbc-button>

    <pbc-button :disabled='!!editingComponent || !hasSelections' @click='remove'>
      <delete class="w-8 h-6" :size='28' />
    </pbc-button>

    <div class="text-sm text-white my-auto text-center">{{ctaMessage}}</div>
    <pbc-button @click="onPlay"
                class="md:grow self-end md:self-center"
                :disabled='disablePreview'
                :class='highlightPreview ? "pbc-primary-color" : "" '>
      <play class="h-8" :size='32' title="Play" />
      Preview
    </pbc-button>

    <pbc-popup v-if='showMenu' @close='showMenu = false'>
      <div class="flex flex-col">
        <pbc-button @click="$emit('layers')"><layers />Layers</pbc-button>
        <pbc-button @click="$emit('zoomIn')"><magnify-plus />Zoom In</pbc-button>
        <pbc-button @click="$emit('zoomOut')"><magnify-minus />Zoom Out</pbc-button>
      </div>
    </pbc-popup>

    <pbc-popup v-if='showRemovePrompt' @close='cancelRemove'>
      <div class="flex flex-col p-2">
        <h3 class="text-lg font-bold p-1">Delete the toy?</h3>
        <pbc-button class="m-1" @click="continueRemove"><check />Yes, remove it.</pbc-button>
        <pbc-button class="m-1" @click="cancelRemove"><close/>No, keep it.</pbc-button>
      </div>
    </pbc-popup>

  </div>
</template>
<script>
import Delete from '@icons/Delete.vue';
import PbcPopup from '@ui/molecules/PbcPopup.vue';
import Play from '@icons/Play.vue';
import Menu from '@icons/Menu.vue';
import MagnifyMinus from '@icons/MagnifyMinus.vue';
import MagnifyPlus from '@icons/MagnifyPlus.vue';
import Layers from '@icons/Layers.vue';
import Check from '@icons/Check.vue';
import Close from '@icons/Close.vue';

export default {
  props: {
    noTransformsAdded: {
      type:Boolean,
      default:false
    },
    disablePreview: {
      type:Boolean,
      default:false
    },
    ctaMessage: {
      type: String,
      required: true
    },
    cameraNotCenter:{
      type:Boolean,
      default: false
    },
    selectionsData: {
      type:Array,
      required:true
    },
    editingComponent: {
      type:Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      showClonePopup: false,
      highlightPreview: false,
      showMenu: false,
      showRemovePrompt: false
    }
  },
  components:{
    Play,
    PbcPopup,
    MenuIcon: Menu,
    Layers,
    MagnifyMinus,
    MagnifyPlus,
    Delete,
    Check,
    Close,
  },
  methods: {
    onPlay() {
      this.highlightPreview = false;
      this.$emit("play");
    },
    continueRemove() {
      const transformsToRemove = this.transformsToRemove;
      this.$emit("remove", {
        transformsToRemove
      });
      this.cancelRemove();
    },
    cancelRemove() {
      this.showRemovePrompt = false;
    },
    remove() {
      const activeSelections = this.selectionsData.filter( (sd) => {
        return !sd.indirectlySelected;
      });

      this.transformsToRemove = activeSelections.map( ({parentTransform, transform}) => {
        return {
          parent: parentTransform,
          child: transform
        }
      });

      this.showRemovePrompt = true;

    }
  },
  computed: {
    hasSelections() {
      return !!this.selectionsData.length;
    },
  },
  watch:{
    noTransformsAdded(nv,ov) {
      if (!nv && ov) {
        this.highlightPreview = true;
      }
    },
    showMenu(nv) {
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'showMenu',
        extra:{nv}
      });
    }
  }
}
</script>
<style>
.toolbar-anon-button {
  @apply h-4 flex-none my-auto self-start;
}
</style>
